module.exports = new __parcel__URL__("connectWorkflow.af1f1d82.svg").toString();